module.exports = __webpack_public_path__ + "static/media/ic-close-player.cad1be3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-close-player.svg
// module id = 652
// module chunks = 0